"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var convertPercentProgressToCoef = function convertPercentProgressToCoef(percent) {
  return percent / 100;
};
var StyledLoaderBar = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", "\n"])), function (props) {
  return props.theme.primaryColor;
});
var HorizontalLoader = function HorizontalLoader(_ref) {
  var progress = _ref.progress;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(StyledLoaderBar, {
    className: _styles.default.bar,
    style: {
      transform: "scaleX(".concat(convertPercentProgressToCoef(progress), ")")
    }
  }));
};
HorizontalLoader.propTypes = {
  progress: _propTypes.default.number.isRequired
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(HorizontalLoader);